import { Document, StyleSheet, View } from '@react-pdf/renderer';

import { Page } from '../../../../components/PdfExportV2/Page/Page.tsx';
import { ExportCommentarySection } from '../ExportCommentarySection.tsx';
import { ExportListItem } from '../ExportListItem.tsx';

const styles = StyleSheet.create({
  listWrapper: {
    gap: '5px',
  },
});

export const ExportQAResults = ({
  address,
  qaResults,
}: {
  address: string;
  qaResults: string[];
}) => (
  <Document>
    <Page title="">
      <ExportCommentarySection subjectAddress={address} title="QC Results">
        <View style={styles.listWrapper}>
          {qaResults.map((result, idx) => (
            <ExportListItem key={`${idx}-${result}`} size="md" text={result} index={idx + 1} />
          ))}
        </View>
      </ExportCommentarySection>
    </Page>
  </Document>
);
